import * as utils from './utils'

export const useTranslations = () => ({
  ...utils,
})

export const _ = null
